
export enum ComponentTypes
{
    OperationalAsset = 1,
    AnalyticalAsset = 2,
    NumericalSensor = 3,
}
